import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Label } from "@/components/ui/label";

interface EditorFieldProps {
  label: string;
  name: string;
  defaultValue?: string | number;
  type?: "text" | "textarea" | "number" | "color";
  required?: boolean;
  rows?: number;
}

export const EditorField = ({ 
  label, 
  name, 
  defaultValue = "", 
  type = "text",
  required = false,
  rows = 3 
}: EditorFieldProps) => {
  return (
    <div>
      <Label className="text-sm font-medium">{label}</Label>
      {type === "textarea" ? (
        <Textarea
          name={name}
          defaultValue={String(defaultValue)}
          className="mt-1"
          rows={rows}
          required={required}
        />
      ) : (
        <Input
          type={type}
          name={name}
          defaultValue={String(defaultValue)}
          className="mt-1"
          required={required}
        />
      )}
    </div>
  );
};